export default "__VITE_ASSET__fenssj9d__"